import { useMemo } from 'react';

import { buildLogoUrl } from '@/lib/branding/build-logo-url';
import { useEffectiveBranding } from '@/hooks/use-effective-branding';

export const useEffectiveLogoUrl = () => {
  const brand = useEffectiveBranding();
  return useMemo(() => buildLogoUrl(brand.logo), [brand.logo]);
};
